import React from 'react'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'

import styles from './style.module.scss'
import cAffairs from '@assets/images/CurrentAffairs.png'
import health from '@assets/images/health.jpeg'
import Entertainment from '@assets/images/artculture.jpg'
import Csit from '@assets/images/csit.jpg'
import business from '@assets/images/business.webp'

const MyImage = dynamic(() => import('@shared-components/myImage'))
const CustomLink = dynamic(() => import('@shared-components/customLink'))

const TopCategories = () => {
  const { t } = useTranslation()

  const data = [
    { title: 'General News & Current Affairs', src: cAffairs },
    { title: 'Health & Medicine', src: health },
    { title: 'Entertainment, Art & Culture', src: Entertainment },
    { title: 'Science & Technology', src: Csit },
    { title: 'Business, Finance & Economics', src: business }
  ]

  return (
    <>
      <section className="mb-3 mb-md-4">
        <h4 className="line-title mb-2 mb-md-3 mt-4 text-uppercase overflow-hidden">
          <span className="position-relative d-inline-block text-nowrap t-ellipsis ms-0 ms-sm-4 ms-lg-5">{t('common:TopCategories')}</span>
        </h4>
        <div className={`${styles.list} d-flex overflow-auto text-center`}>
          {
            data.map((category, index) => (
              <div key={index} className={`${styles.item} common-box p-0 mx-1 overflow-hidden`}>
                <MyImage src={category?.src} className="w-100 h-auto"
                  alt="title" width="118" height="120" />
                <CustomLink href={'/'} prefetch={false} className="d-block p-2 xsmall-text fw-bold">
                  {category?.title}
                </CustomLink>
              </div>
            ))
          }
        </div>
      </section>
    </>
  )
}
export default TopCategories
